import type { TNotificationPublicProps } from '../models';

export const config: Partial<TNotificationPublicProps> = { offset: 108 };
